
import React from 'react';
import { Instagram, Palette, Globe } from 'lucide-react';

const Services = () => {
  const services = [
    {
      title: 'Social Media',
      icon: <Instagram className="w-12 h-12 text-grow99x-orange mb-4" />,
      description: 'Daily photo/video content to keep your audience engaged and excited about your business.',
    },
    {
      title: 'Branding',
      icon: <Palette className="w-12 h-12 text-grow99x-orange mb-4" />,
      description: "Friendly & modern branding that's consistent across all your digital touchpoints.",
    },
    {
      title: 'Digital Presence',
      icon: <Globe className="w-12 h-12 text-grow99x-orange mb-4" />,
      description: "Your customers can find you easily online, anytime they're craving what you offer.",
    },
  ];

  return (
    <section id="services" className="section-container">
      <div className="text-center mb-16">
        <h2 className="text-3xl md:text-4xl font-bold mb-4">What We Do</h2>
        <div className="h-1 w-20 bg-grow99x-orange mx-auto"></div>
      </div>
      
      <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
        {services.map((service, index) => (
          <div key={index} className="card flex flex-col items-center text-center">
            {service.icon}
            <h3 className="text-xl font-bold mb-3">{service.title}</h3>
            <p className="text-gray-600">{service.description}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Services;
